<template lang="pug">
  .syncUseCase(v-on:click="$emit('click')").mt-1
    .content
        .row
            .col-8
                .row.py-3
                    .col-6.colcustom.px-0.py-3
                        .fieldContent.px-3  
                            img(:src="syncType.source.icon" width="40px")
                            span {{syncType.source.name}}
                    .col-4.colcustom.px-0.py-3
                        .fieldContent.px-3
                            img(:src="syncType.destination.icon" width="40px")
                            span {{syncType.destination.name}}
                    .col-2.colcustom.align-items-center.py-3
                        .fieldContent
                            img(src="@/assets/imgs/selectButton.svg")
                hr.m-0.p-0
            .col-4.info
                .row.d-flex.align-items-center.py-3
                    .col-8.px-4
                        .infoContent {{syncType.description}}
                    .col-4 
                        button.mt-4.customButton.docsButton
                            router-link(to="/docs") Read the docs
</template>

<script>
export default {
  name: 'SyncUseCase',
  props:{
      syncType: Object
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import url('@/less/global.less');

    .syncUseCase {
        cursor: pointer;
        .content{ 
            overflow: hidden;
        }
        .fieldContent {
            font-size: 20px; 
        }

        .colcustom {
            // padding: 30px;
        }

        .info {
            background-color: rgba(229, 229, 229, .35);
        }

        .infoContent {
            font-size: 14px;
        }

        .content{
            // padding: 30px;
        }
        .docsButton {
            font-size: 14px;
            background-color: white !important;
        }
    }
</style>
